import type { PropsWithChildren } from 'react';
import { Suspense, lazy } from 'react';

import Skeleton from './skeleton';

const Typography = lazy(() => import('@mui/material/Typography'));

// TODO: refactor types

interface IProps {
  [x: string]: unknown;
  height?: string | number;
  width?: string | number;
  className?: string;
}

function Preloader({
  width,
  height,
  className,
}: PropsWithChildren<{
  width?: string | number;
  height?: string | number;
  className?: string;
}>) {
  return <Skeleton width={width} height={height} variant="text" className={className} />;
}

function AtpTypography({ height, width, className, ...rest }: PropsWithChildren<IProps>) {
  return (
    <Suspense fallback={<Preloader height={height} width={width} className={className} />}>
      <Typography {...rest} className={className} />
    </Suspense>
  );
}

export default AtpTypography;
